import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetProjectCommentsByID = (ID) => Axios.get(`/projects/comments/${ID}`);

const useProjectComments = (ID) => {
    return useQuery({
        queryKey: ['projectcomments', ID],
        queryFn: () => onGetProjectCommentsByID(ID),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadProjectComments = (ID) => {
    return queryClient.invalidateQueries({ queryKey: ['projectcomments', ID] });
};

export { useProjectComments, forceReloadProjectComments };
